export default function modifyFooterBehaviour() {
  const isPresent = document.querySelector(".footer-fixed");
  if (!isPresent) {
    return;
  }

  function adjustFooterPadding() {
    // Get the height of the .footer-fixed element
    const footerFixedHeight =
      document.querySelector(".footer-fixed").offsetHeight;
    // Set the padding-bottom of the .footer-general element
    document.querySelector(".footer-general").style.paddingBottom =
      footerFixedHeight + "px";
  }

  function checkFooterVisibility() {
    const footerFixed = document.querySelector(".footer-fixed");
    const footerContent = document.querySelector(".footer-content");
    const footerContentRect = footerContent.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (footerContentRect.bottom <= windowHeight) {
      // If the bottom of the footer-content is within the viewport, remove the footer-fixed--visible class
      footerFixed.classList.remove("footer-fixed--hidden");
    } else {
      // If the bottom of the footer-content is not within the viewport, add the footer-fixed--visible class
      footerFixed.classList.add("footer-fixed--hidden");
    }
  }

  // Adjust the padding on page load
  window.addEventListener("load", () => {
    adjustFooterPadding();
    checkFooterVisibility();
  });
  // Adjust the padding and check visibility on window resize
  window.addEventListener("resize", () => {
    adjustFooterPadding();
    checkFooterVisibility();
  });
  // Check visibility on scroll
  window.addEventListener("scroll", checkFooterVisibility);
}
